import React from 'react';
import Icon from './icon.jsx';

export const DELAY_5_S = 5000;

export const Notification = ({ text, onClose }) => (
  <div className="notification" role="status">
    <div className="notification__checkmark">
      <Icon type="checkmark" />
    </div>
    <div className="notification__text"><b>{text}</b></div>
    <button aria-label="Close notification" className="notification__close" onClick={onClose} type="button">
      <Icon type="close" />
    </button>
  </div>
);
